import React from 'react'
import { Trans } from '@lingui/react'

import TextArea from '../../../util/TextArea'
import FormItem from '../../../util/FormItem'
import ProjectSearchSelect from '../../../util/ProjectSearchSelect'

const StartActivityForm = ({ formState, projectGuesses, isFetching }) => {
    const {
        values,
        getValue,
        getErrorMessages,
        getInputProps,
        getNativeInputProps,
        handleChangeProject,
    } = formState
    let invoicingLanguage = ''
    if (
        values.project !== null &&
        typeof values.project.invoicingLanguage !== 'undefined'
    ) {
        invoicingLanguage = `(${formState.values.project.invoicingLanguage.translation})`
    }
    return (
        <>
            <FormItem
                label={<Trans id="Project" />}
                error={getErrorMessages('project')}
            >
                <div className="flex flex-row items-center justify-between gap-x-4">
                    <ProjectSearchSelect
                        id="activityFormProjectSearchSelect"
                        {...getInputProps('project')}
                        defaultOptions={projectGuesses}
                        onChange={handleChangeProject}
                        disabled={isFetching}
                        className="flex-1"
                        position='bottom-start'
                    />
                </div>
            </FormItem>
            <FormItem
                label={<Trans 
                    id = "Description {invoicingLanguage}"
                    values = {{ invoicingLanguage }} />}
                error={getErrorMessages('description')}
                required
            >
                <TextArea minRows="5" {...getNativeInputProps('description')} />
            </FormItem>
        </>
    )
}

export default StartActivityForm
